/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Parentid2Inputs */

const de__field_parentid2 = /** @type {(inputs: _Field_Parentid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergeordnete Kooperationspartnereinheit ID`)
};

/**

* @param {_Field_Parentid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_parentid2 = /** @type {((inputs?: _Field_Parentid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Parentid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_parentid2(inputs)
});
export { _field_parentid2 as "_field_parentID" }